import React from "react";

export type TagColour = "red" | "blue" | "grey" | "yellow" | "orange" | "green" | "green-300" | "green-200" | "beige" | "light-green";

interface TagProps {
  className?: string;
  colour?: TagColour;
  dataTestId?: string;
  size?: string;
  style?: React.CSSProperties;
  text?: string | React.ReactNode;
}

export const Tag = ({ className, colour = "blue", dataTestId = "", size, style, text }: TagProps) => (
  <div className={`tag standard ${colour} ${className ?? ""} ${size ?? ""}`} style={style} data-testid={dataTestId}>
    {text}
  </div>
);
